(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["avantages-produit"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    new Swiper('.target-inch-swiper', {
      slidesPerView: 'auto',
      spaceBetween: 15,
      freeMode: true,
      grabCursor: true,
      breakpoints: {
        0: {
          slidesPerView: 2.5
        },
        769: {
          slidesPerView: 'auto'
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banniere-produit"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const bgSection = document.querySelector('.bg-section');
  if (!bgSection) return;

  function updateBackgroundImage() {
    const isMobile = window.innerWidth <= 768;
    const newBg = isMobile ? bgSection.dataset.bgMobile : bgSection.dataset.bgDesktop;
    if (newBg) {
      bgSection.style.backgroundImage = `url('${newBg}')`;
    }
  }

  updateBackgroundImage();
  window.addEventListener('resize', updateBackgroundImage);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-text"] && !Shopify.designMode) return;
  try {
    
  
  (function(){
    if (typeof Swiper === 'undefined') { return; }
    var root = document.querySelector('.homepage-icons .mobile-swiper');
    if (!root) { return; }

    if (root.__inited) { return; }
    root.__inited = true;

    new Swiper(root, {
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 16,
      autoHeight: true,
      pagination: {
        el: root.querySelector('.swiper-pagination'),
        clickable: true
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredients"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".tab-buttons button");
  const items = document.querySelectorAll(".tab-item");

  function updateDisplay(selectedTab) {
    items.forEach(item => {
      const tabs = item.dataset.tabs.split(',').map(t => t.trim().toLowerCase());
      if (tabs.includes(selectedTab)) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  const firstTab = buttons[0]?.dataset.tab.toLowerCase().trim();
  if (firstTab) updateDisplay(firstTab);

  buttons.forEach(button => {
    button.addEventListener("click", () => {
      buttons.forEach(btn => btn.classList.remove("active"));
      button.classList.add("active");
      updateDisplay(button.dataset.tab.toLowerCase().trim());
    });
  });
});


  } catch(e) { console.error(e); }
})();
})();
